import React from 'react';
import RegisterInterest from '../../components/modals/RegisterInterest/RegisterInterest';

const Enterprise: React.FC = () => {
  return (
    <>
      {/* Hero — statement */}
      <section className="ent-hero">
        <div className="ent-hero-content">
          <p className="about-kicker">VoyCalc Enterprise</p>
          <h1 className="ent-statement">
            Your fleet, your team, your agents —<br />
            <span className="hero-highlight">one workspace.</span>
          </h1>
          <p className="ent-sub">
            The full VoyCalc platform in your company's own single-tenant deployment — SSO, shared
            data, and MCP access for your AI agents.
          </p>
          <div className="ent-domain-pill">
            <i className="bi bi-shield-lock"></i>
            yourcompany.voycalc.com
          </div>
          <div className="mt-4">
            <RegisterInterest showSubtext={false} />
          </div>
          <p className="enterprise-hero-note">
            Our free Pro Beta is closed — VoyCalc is available for enterprise teams only.
          </p>
        </div>
      </section>

      {/* Platform index */}
      <section className="ent-platform">
        <div className="ent-container">
          <p className="about-story-label">The Full Platform</p>
          <h2 className="ent-heading">Everything your desk runs on.</h2>
          <div className="ent-index">
            <div className="ent-index-item">
              <i className="bi bi-calculator"></i>
              <div>
                <h3>Advanced Calc</h3>
                <p>Fast, precise voyage estimates with efficient re-use of your own data.</p>
              </div>
            </div>
            <div className="ent-index-item">
              <i className="bi bi-globe"></i>
              <div>
                <h3>Routing & Distances</h3>
                <p>Global distance tables with ECA and HRA route optimisation.</p>
              </div>
            </div>
            <div className="ent-index-item">
              <i className="bi bi-clouds"></i>
              <div>
                <h3>Emissions & Compliance</h3>
                <p>Advanced emission calculations — ETS and FuelEU on every estimate.</p>
              </div>
            </div>
            <div className="ent-index-item">
              <i className="bi bi-fuel-pump"></i>
              <div>
                <h3>Bunker Services</h3>
                <p>Provider prices along your exact route.</p>
              </div>
            </div>
            <div className="ent-index-item">
              <i className="bi bi-wind"></i>
              <div>
                <h3>Weather Factor</h3>
                <p>Advanced weather factor simulation on your sea legs.</p>
              </div>
            </div>
            <div className="ent-index-item">
              <i className="bi bi-collection"></i>
              <div>
                <h3>Vessels & Clients</h3>
                <p>Your fleet and client lists kept ready for the next estimate.</p>
              </div>
            </div>
            <div className="ent-index-item">
              <i className="bi bi-cash-coin"></i>
              <div>
                <h3>Port Cost Memory</h3>
                <p>Port costs remembered and re-used across your estimates.</p>
              </div>
            </div>
            <div className="ent-index-item">
              <i className="bi bi-stars"></i>
              <div>
                <h3>AI Agents (MCP)</h3>
                <p>Claude and other MCP agents work directly in your workspace.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Enterprise foundation — definition list */}
      <section className="ent-foundation">
        <div className="ent-container">
          <div className="ent-foundation-grid">
            <p className="about-story-label">Built for Enterprise</p>
            <div className="ent-deflist">
              <div className="ent-def">
                <h3>Single-Tenant Workspace</h3>
                <p>
                  Your own isolated deployment at yourcompany.voycalc.com. Your data lives in your
                  workspace and is never shared with other tenants.
                </p>
              </div>
              <div className="ent-def">
                <h3>SSO Integration</h3>
                <p>
                  Sign in with your company's identity provider. Access is managed centrally by
                  your own administrators.
                </p>
              </div>
              <div className="ent-def">
                <h3>Shared Vessels, Calcs & Contacts</h3>
                <p>
                  One shared library for the whole team — everyone estimates from the same vessels,
                  clients and port cost history.
                </p>
              </div>
              <div className="ent-def">
                <h3>Custom Integrations</h3>
                <p>
                  Connect your VMS, bunker desks and market data providers — we tailor the
                  integrations to your workflow.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Getting started — timeline */}
      <section className="ent-steps">
        <div className="ent-container ent-steps-center">
          <p className="about-story-label">Getting Started</p>
          <h2 className="ent-heading">From first call to first estimate.</h2>
          <div className="ent-timeline">
            <div className="ent-tl-step">
              <span className="ent-tl-num">01</span>
              <h3>Register Interest</h3>
              <p>Tell us who you are and how your team works today.</p>
            </div>
            <div className="ent-tl-step">
              <span className="ent-tl-num">02</span>
              <h3>Demo & Walkthrough</h3>
              <p>A live session on your own voyages, with your own vessels and trades.</p>
            </div>
            <div className="ent-tl-step">
              <span className="ent-tl-num">03</span>
              <h3>Onboarding</h3>
              <p>Your own workspace set up, SSO connected and your team invited.</p>
            </div>
          </div>
          <p className="ent-pricing-note">
            Pricing is tailored to your fleet and team — we'll walk you through it in the demo.
          </p>
          <div className="about-cta" style={{ borderTop: 'none', marginTop: '1.5rem' }}>
            <p className="about-cta-text">Ready to see VoyCalc on your own voyages?</p>
            <RegisterInterest showSubtext={false} />
          </div>
        </div>
      </section>
    </>
  );
};

export default Enterprise;
